import axios from "axios";

const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const postLink = async ({ currentPageId, link, admin }) => {
  return await axios({
    method: "post",
    url: API_URL + `admin/pages/${currentPageId}/link`,
    data: link,
    headers: {
      "Content-Type": "application/json",
      "x-access-token": admin.accessToken,
    },
  });
};

const deleteLink = async ({ currentPageId, admin, linkId }) => {
  return await axios({
    method: "delete",
    url: API_URL + `admin/pages/${currentPageId}/link/${linkId}`,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });
};

const linkService = {
  postLink,
  deleteLink,
};

export default linkService;
